import { push } from 'react-router-redux';
import { endpoint } from '../../helpers/Endpoints';
import Routes from '../../helpers/Routes';
import type { IToastMessage } from '../../helpers/Toastr';
import { toastr } from '../../helpers/Toastr';
import * as FetchAction from '../FetchActionGeneric';
import type { DispatchFunc } from '../types';

export const SELF_SERVICE_GET_CUSTOMERS = '@sss.cm:SELF_SERVICE_GET_CUSTOMERS';
export const SELF_SERVICE_GET_CUSTOMERS_SUCCESS =
	'@sss.cm:SELF_SERVICE_GET_CUSTOMERS_SUCCESS';
export const SELF_SERVICE_GET_CUSTOMERS_ERROR =
	'@sss.cm:SELF_SERVICE_GET_CUSTOMERS_ERROR';

export function GetCustomers(
	currentPage: number,
	itemsPerPage: number,
	filter: string
) {
	return FetchAction.CreateFetchAction({
		startAction: SELF_SERVICE_GET_CUSTOMERS,
		method: 'GET',
		url: endpoint.syscoSelfService.getCustomers(currentPage, itemsPerPage, {
			filter,
		}),
		startActionPayload: {
			currentPage: currentPage || 1,
			itemsPerPage,
		},
	});
}

export const SELF_SERVICE_FILTER_CHANGE = '@sss.cm:SELF_SERVICE_FILTER_CHANGE';
export const SELF_SERVICE_FILTER_CHANGE_SUCCESS =
	'@sss.cm:SELF_SERVICE_FILTER_CHANGE_SUCCESS';
export const SELF_SERVICE_FILTER_CHANGE_ERROR =
	'@sss.cm:SELF_SERVICE_FILTER_CHANGE_ERROR';

export function FilterCustomer(payload: string) {
	return {
		type: SELF_SERVICE_FILTER_CHANGE,
		payload,
	};
}

export interface ICreateCustomerRequest {
	name: string;
	nationalId: string;
	attributeIds: number[];
}
export const SELF_SERVICE_CREATE_CUSTOMER =
	'@sss.cm:SELF_SERVICE_CREATE_CUSTOMER';
export const SELF_SERVICE_CREATE_CUSTOMER_SUCCESS =
	'@sss.cm:SELF_SERVICE_CREATE_CUSTOMER_SUCCESS';
export const SELF_SERVICE_CREATE_CUSTOMER_ERROR =
	'@sss.cm:SELF_SERVICE_CREATE_CUSTOMER_ERROR';

export function CreateCustomer(
	request: ICreateCustomerRequest,
	toastMessage: IToastMessage
) {
	return FetchAction.CreateFetchAction({
		startAction: SELF_SERVICE_CREATE_CUSTOMER,
		method: 'POST',
		url: endpoint.syscoSelfService.createCustomer(),
		body: JSON.stringify(request),
		onAfterSuccess: (data: number, dispatch: DispatchFunc) => {
			toastr.success(toastMessage);
			dispatch(push(Routes.syscoSelfService.manageLocations(data)));
		},
	});
}
